/** SEO / category-card / meta-description budget for catalog short descriptions. */
export const STAGED_SHORT_DESCRIPTION_MAX_CHARS = 160;

export function clampShortDescription(
  text: string,
  maxChars = STAGED_SHORT_DESCRIPTION_MAX_CHARS,
): string {
  const t = String(text || '').trim().replace(/\s+/g, ' ');
  if (!t || t.length <= maxChars) return t;
  const head = t.slice(0, maxChars);
  const sp = head.lastIndexOf(' ');
  return (sp > maxChars * 0.35 ? head.slice(0, sp) : head).trimEnd();
}

export function isShortDescriptionIssueField(field: string): boolean {
  const f = String(field || '').toLowerCase().trim();
  if (!f) return false;
  const compact = f.replace(/[\s._-]+/g, '');
  return compact === 'shortdescription' || compact === 'descriptionshort';
}
